import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const MenuContainer = styled.div`
    position: absolute;
    top: ${({ rightClickMenuYPos }) => rightClickMenuYPos}px;
    left: ${({ rightClickMenuXPos }) => rightClickMenuXPos}px;
    width: 175px;
    height:auto;
    border: 1px solid #eee;
    border-radius: 2.5px;
    background:#fff;
`;

const RightClickMenu = ({
    rightClickMenuXPos,
    rightClickMenuYPos,
    clickOnItemInRightMenu,
    pasteText,
}) => (
  <MenuContainer className="right-click-menu-container" rightClickMenuXPos={rightClickMenuXPos} rightClickMenuYPos={rightClickMenuYPos} >
    <ul>
      <li><span role="button" tabIndex={0} onClick={() => clickOnItemInRightMenu('paste')}>{pasteText}</span></li>
    </ul>
  </MenuContainer>
);

RightClickMenu.propTypes = {
  rightClickMenuXPos: PropTypes.number,
  rightClickMenuYPos: PropTypes.number,
  clickOnItemInRightMenu: PropTypes.func,
  pasteText: PropTypes.string,
};

export default RightClickMenu;



// WEBPACK FOOTER //
// ./src/components/organisms/ImportFile/blocks/rightClickMenu.js